import React from "react";
import { useQueries, useQuery } from 'react-query'
import { getResultsRSC, getUnits } from "data/Querys"
import Loader from 'components/general/Loader'
import NotAvailable from "components/common/NotAvailable";
import PageHeader from "components/common/PageHeader";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import ProgressionRule from "components/common/ProgressionRule";
import ShoResults from "components/sports/sho/views/ShoResults";
import { getPhaseRSC } from "helpers/rsc";
import { useEventUnit } from "components/common/EventUnit";

const ShoContext = () => {
    const { mirs_discipline, mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    //GET UNITS IN PHASE
    const { data: unitsData, isError: unitsError, isLoading: unitsLoading } = useQuery(
        {
            queryKey: ['unitsPhase', mirs_competition, mirs_language, getPhaseRSC(mirs_rsc), 'S'],
            queryFn: getUnits,
            //refetchInterval: 30000,
            staleTime: Infinity,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        }
    );
    

    //datos para el marcador y estadisticas
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['resultsData', mirs_competition, mirs_rsc, mirs_language],
            queryFn: getResultsRSC,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            //enabled: !!confCategory
            onError: (error) =>
                console.error(`Something went wrong: ${error.message}`),
    });

    let queryArray = [];
        //GET ALL RESULTS IN PHASE 
    unitsData?.phase?.units?.forEach((unit) => {
        queryArray.push({
            queryKey: ['resultsData', mirs_competition, unit.code, mirs_language],
            queryFn: getResultsRSC,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        })
    });

    const eu = useEventUnit()

    const results = useQueries(queryArray);
    const isLoading_ = isLoading ||unitsLoading || results.some(result => result.isLoading)
    const isError_ = isError || unitsError || results.some(result => result.isError)



    if (isError_) { return <NotAvailable />; }
    if (isLoading_) { return <Loader />; }
    const realData = results.filter(res => res.data.results)
    if (!data?.results && !(Array.isArray(realData) && realData.length > 0)) { return <NotAvailable /> }

    const out1 =  data?.results && (
        <>
            <PageHeader data={data} />
            <div className='mirs-page-container'>
                <ProgressionRule
                    key="progress-component"
                    data={data?.config}
                    filter={{ type: ['QUALIFICATION'], code: ['QUAL_RULE'] }}
                />
                <div className='my-5'>
                    <ShoResults data={data} />
                </div>
            </div>
        </>
    );
    
    const out2 =  !data?.results && Array.isArray(realData) && realData.length > 0 && (
        <>
            <PageHeader title={unitsData?.phase?.description}/>
        
            {realData?.map(item => (
                <div className='mirs-page-container' key={item?.data?.results?.eventUnitCode}>
                    <h4>{eu(item?.data?.results?.eventUnitCode, true)}</h4>
                    <ProgressionRule
                        key="progress-component"
                        data={item?.data?.config}
                        filter={{ type: ['QUALIFICATION'], code: ['QUAL_RULE'] }}
                    />
                    <div className='my-5'>
                        <ShoResults data={item?.data} />
                    </div>
                </div>
            ))}
        </>
    );

    return out1 || out2;
    
}

export default ShoContext;